import { useState } from 'react'

import { getFormikEntityActionConfigFieldsInitialValuesPayload } from '../../components/Formik'
import {
  EMPTY_OBJECT,
  ENTITY_KEY_ID,
  ENTITY_KEY_UUID,
} from '../../constants/common'
import {
  getMassActionExcludeIdParam,
  getMassActionIdParam,
} from '../../utils/common'
import { getIdFilterParam } from '../../utils/filter'

export function usePerformMassAction({
  excludeIds,
  filterValues,
  getAsyncTaskId,
  isUuid,
  massActionNames,
  pagination,
  performApi,
  selectAllPages,
  selectedIds,
  sub,
  onAddAsyncMassActionNotification,
  onAddFinishMassActionNotification,
  onCleanSelection,
  onCloseModal,
  onErrorAction,
  onReload,
}) {
  const [isPerformingMassAction, setPerformingMassAction] = useState(false)

  function massAction({
    action,
    actionType,
    asyncTaskHandler,
    ids,
    value = EMPTY_OBJECT,
  }) {
    const id = getMassActionIdParam({ ids, selectAllPages, selectedIds })

    const excludeIdsParam = getMassActionExcludeIdParam({
      excludeIds,
      selectAllPages,
    })

    const idKey = isUuid ? ENTITY_KEY_UUID : ENTITY_KEY_ID

    const excludeIdsParamKey = isUuid ? 'exclude_uuid' : 'exclude_id'

    const params = {
      ...getFormikEntityActionConfigFieldsInitialValuesPayload(actionType),
      action: massActionNames[action],
      all: selectAllPages,
      filters: {
        ...filterValues,
        [excludeIdsParamKey]: excludeIdsParam,
        [idKey]: getIdFilterParam({
          filterKey: idKey,
          filterValues,
          ids: id,
          selectAllPages,
        }),
      },
      payload: value,
    }

    const countOfItems = selectAllPages ? pagination.count : id.length

    onCloseModal()

    setPerformingMassAction(true)

    performApi(params)
      .then(({ data, status }) => {
        onCleanSelection()

        const asyncTask = getAsyncTaskId(data)

        if (asyncTask) {
          if (asyncTaskHandler) {
            asyncTaskHandler({
              action,
              status,
              sub,
              task: asyncTask,
            })
          } else {
            onAddAsyncMassActionNotification?.({
              action,
              pathname: location.pathname,
              sub,
              task: asyncTask,
              totalCount: countOfItems,
            })
          }

          return
        }

        onReload()

        onAddFinishMassActionNotification(data, {
          action,
          totalCount: countOfItems,
        })
      })
      .catch(error => {
        onErrorAction(error)
      })
      .finally(() => {
        setPerformingMassAction(false)
      })
  }

  return {
    isPerformingMassAction,
    massAction,
    setPerformingMassAction,
  }
}
